import React, { useEffect, useMemo, useState } from 'react';
import CourseCard from '../../Reusable/CourseCard';
import { axiosInstance } from '../config';
import Loader from '../../common/Loader';

const CourseList = ({ sortType, sortDirection, transmissionType }) => {
  const [Courses, setCourses] = useState([]);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    setLoading(true);

    axiosInstance
      .get(`get-cources`)
      .then((res) => {
        setCourses(
          res.data.cources.filter((course) => course.status === 0).reverse()
        );
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setLoading(false);
      });
  }

  const visibleCourses = useMemo(() => {
    const normalizedTransmission = transmissionType?.toLowerCase() || 'all';

    const getCourseValue = (course, keys) => {
      for (const key of keys) {
        const value = course?.[key];
        if (value !== undefined && value !== null && `${value}`.trim() !== '') {
          return `${value}`.trim();
        }
      }
      return '';
    };

    const getCourseTransmission = (course) => {
      return getCourseValue(course, [
        'cartype',
        'carType',
        'car_type',
        'transmission',
        'vehicleType',
        'vehicle_type',
      ]).toLowerCase();
    };

    const getCoursePrice = (course) => {
      const rawPrice = getCourseValue(course, [
        'price',
        'amount',
        'course_price',
        'price_value',
      ]);
      const numericPrice = rawPrice.replace(/[^0-9.-]/g, '');
      const parsedPrice = Number(numericPrice);

      return Number.isFinite(parsedPrice) ? parsedPrice : 0;
    };

    const filteredCourses = Courses.filter((course) => {
      if (normalizedTransmission === 'all') return true;

      const transmission = getCourseTransmission(course);
      return transmission.includes(normalizedTransmission);
    });

    const effectiveDirection =
      sortType === 'high-low' || sortDirection === 'descending'
        ? 'desc'
        : 'asc';

    const sortedCourses = [...filteredCourses].sort((a, b) => {
      const priceA = getCoursePrice(a);
      const priceB = getCoursePrice(b);

      return effectiveDirection === 'desc' ? priceB - priceA : priceA - priceB;
    });

    return sortedCourses;
  }, [Courses, sortType, sortDirection, transmissionType]);

  const automaticCourses = useMemo(() => {
    return visibleCourses.filter((course) => {
      const transmission =
        `${course.cartype || course.carType || course.car_type || course.transmission || course.vehicleType || course.vehicle_type || ''}`.toLowerCase();
      return (
        transmission.includes('automatic') || transmission.includes('auto')
      );
    });
  }, [visibleCourses]);

  const manualCourses = useMemo(() => {
    return visibleCourses.filter((course) => {
      const transmission =
        `${course.cartype || course.carType || course.car_type || course.transmission || course.vehicleType || course.vehicle_type || ''}`.toLowerCase();
      return transmission.includes('manual');
    });
  }, [visibleCourses]);

  return (
    <>
      {Loading && <Loader />}
      <section className="course-style-three alternat-2">
        <div className="shape">
          <div
            className="shape-1"
            style={{ backgroundImage: 'url(assets/images/shape/shape-87.png)' }}
          />
          <div
            className="shape-3 float-bob-x"
            style={{ backgroundImage: 'url(assets/images/shape/shape-6.png)' }}
          />
        </div>
        <div className="auto-container">
          <div className="sec-title centred">
            <h2>Course to drive with confidence</h2>
          </div>
          <div className="row clearfix">
            {visibleCourses.length === 0 ? (
              <div className="col-12 text-center py-5">
                <h4>No courses match the selected filters.</h4>
              </div>
            ) : (
              <>
                <div className="col-lg-6 col-md-12">
                  <div className="mb-4">
                    <h3 className="mb-3">Automatic</h3>
                    <div className="row clearfix">
                      {automaticCourses.length > 0 ? (
                        automaticCourses.map((course, index) => {
                          return (
                            <CourseCard
                              key={`automatic-${index}`}
                              course={course}
                            />
                          );
                        })
                      ) : (
                        <div className="col-12 text-center py-4">
                          <p>No automatic courses available.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="mb-4">
                    <h3 className="mb-3">Manual</h3>
                    <div className="row clearfix">
                      {manualCourses.length > 0 ? (
                        manualCourses.map((course, index) => {
                          return (
                            <CourseCard
                              key={`manual-${index}`}
                              course={course}
                            />
                          );
                        })
                      ) : (
                        <div className="col-12 text-center py-4">
                          <p>No manual courses available.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default CourseList;
